export const variantStylesLeads = {
  or: { background: "#C98910", color: "white" },
  argent: { background: "#A8A8A8", color: "white" },
  bronze: { background: "#965A38", color: "white" },
  prince: { background: "#f44336", color: "white" }
};
